import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

@inject('packsStore')
@observer
class Cover extends Component {
  render() {
    return (
      <div
        className='cursor-pointer min-w-[80px] min-h-[80px] lg:min-w-[70px] lg:min-h-[70px]'
        onClick={this.props.onClick}
      >
        <img
          className='w-full'
          src={this.props.cover || this.props.packsStore.getCover(this.props.productId)}
        />
      </div>
    )
  }
}

export default Cover
